import FranceContractType from 'modules/contracts/store/models/FranceContractType'

import { PayrollLegalEntityResource } from 'modules/contracts/store/collections/payrollLegalEntityResource'

class ContractTypes extends PayrollLegalEntityResource<FranceContractType> {
  get cacheKey(): string {
    return 'franceContractTypes'
  }

  model() {
    return FranceContractType
  }
}

export { ContractTypes }
